import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Key20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M6.5 5.5C6.5 6.05228 6.05228 6.5 5.5 6.5C4.94772 6.5 4.5 6.05228 4.5 5.5C4.5 4.94772 4.94772 4.5 5.5 4.5C6.05228 4.5 6.5 4.94772 6.5 5.5Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 11.75C2.82436 11.75 0.25 9.17564 0.25 6C0.25 2.82436 2.82436 0.25 6 0.25C9.17564 0.25 11.75 2.82436 11.75 6L11.7501 7.68937L18.384 14.3233C18.6184 14.5577 18.7501 14.8756 18.7501 15.2071V18C18.7501 18.6904 18.1905 19.25 17.5001 19.25H13.5001C12.8097 19.25 12.2501 18.6904 12.2501 18V16.75L11.0001 16.75C10.3097 16.75 9.7501 16.1904 9.7501 15.5V13.8107L7.68943 11.75L6 11.75ZM1.75 6C1.75 3.65279 3.65279 1.75 6 1.75C8.34721 1.75 10.25 3.65279 10.25 6L10.2501 7.79292C10.2501 8.12444 10.3818 8.44238 10.6162 8.6768L17.2501 15.3107V17.75H13.7501V16.5C13.7501 15.8097 13.1905 15.25 12.5001 15.25L11.2501 15.25L11.2501 13.7071C11.2501 13.3756 11.1184 13.0577 10.884 12.8233L8.67687 10.6161C8.44245 10.3817 8.12451 10.25 7.79299 10.25L6 10.25C3.65279 10.25 1.75 8.34721 1.75 6Z'
      fill='currentColor'
    />
  </Svg>
);

Key20.displayName = 'Key20';
export default Key20;
